import HeadSeo from "@components/HeadSeo/HeadSeo";
import Container from "@ui-kit/Container/Container";
import { addBlankAttrToHtml } from "@utils/utils";

import s from "./CustomsRegulations.module.scss";

const CustomsRegulations = ({ data }) => {
  const { article } = data;

  const seo = {
    title: article?.title ? article?.title : "",
    description: "",
    pageKeywords: "",
    socialTitle: "",
    slug: "",
    socialDescription: "",
    articlePublishedTime: article?.createdAt ? article?.createdAt : "",
    articleModifiedTime: article?.editedAt ? article?.editedAt : "",
  };

  return (
    <div className={s.customsRegulations}>
      <HeadSeo seo={seo} />
      <Container>
        <Container full={false}>
          <section>
            <h1 className={s.title}>{article.title}</h1>
            {article.body && (
              <div
                className={s.article}
                dangerouslySetInnerHTML={{
                  __html: addBlankAttrToHtml(article.body),
                }}
              />
            )}
          </section>
        </Container>
      </Container>
    </div>
  );
};

export default CustomsRegulations;
